import React from 'react';

import './App.css';
import { ContentContainer } from '../features/contentContainer/ContentContainer';
import { OffScreenNavBar } from '../features/offscreenNavBar/OffScreenNavBar';
import { NavEvent } from '../features/nav/NavEvent';
import { Container } from 'react-bootstrap';
import { Footer } from '../features/footer/Footer';
import { ConsentBanner } from '../features/consentBanner/ConsentBanner';
import { usePageTracking } from '../hooks/usePageTracking';
import { analyticsService } from '../services/AnalyticsService';
import { performanceTracker } from '../services/PerformanceTracker';
import { APP_VERSION } from '../version';

function App() {
  const [content, setContent] = React.useState(NavEvent.ABOUT);

  // Initialize analytics service on app startup (non-blocking)
  React.useEffect(() => {
    const initializeAnalytics = async () => {
      try {
        // Check if we're in development or production
        const isDevelopment = process.env.NODE_ENV === 'development';

        if (isDevelopment) {
          console.log('App: Initializing analytics in development mode');
        }

        // Initialize analytics service (non-blocking)
        await analyticsService.initialize();

        // Initialize performance tracking (non-blocking)
        await performanceTracker.initialize();

        // Log app startup event
        analyticsService.logEvent('app_startup', {
          environment: isDevelopment ? 'development' : 'production',
          version: APP_VERSION,
          analytics_ready: analyticsService.isReady(),
          performance_ready: performanceTracker.isReady(),
        });
      } catch (error) {
        // Analytics initialization should never block the app
        console.warn('App: Analytics initialization failed, continuing without analytics:', error);
      }
    };

    // Initialize analytics without blocking the UI
    initializeAnalytics();
  }, []);

  // Track page views automatically
  usePageTracking(content);

  function onSelect(key: NavEvent) {
    setContent(key);
  }

  return <Container fluid>
    <OffScreenNavBar onSelect={onSelect} />
    <ContentContainer content={content} />
    <ConsentBanner />
    <Footer />
  </Container>;
}

export default App;
